import { Box, Button, TextField } from '@mui/material';
import { Avatar, Grid, IconButton, Typography } from '@mui/material/node';
import { useNavigate } from 'react-router-dom';
import * as React from 'react';

export const UserAvatar = (props) => {
    const [userData, setUserData] = React.useState({
        name: props.userData?.name,
        bio: props.userData?.bio,
        piculr: props.userData?.piculr
    });

    const handleChange = (e) => {
        const name = e.target.name;
        const value = e.target.value;
        setUserData((prev) => {
            return { ...prev, [name]: value }
        });
    };

    const handleSave = (e) => {
        props.saveProfile(userData);
    };

    React.useEffect(() => {

    }, [userData]);

    if (props.readolny && props.readolny === true) {
        return (

            <Avatar
            alt="asd"
                sx={{ width: 128, height: 128, }}>
                    
            </Avatar>
        );
    }
    else {
        return (
<>
            <Avatar
            alt="asd"
            src={props.userData?.picurl}
                sx={{ width: 128, height: 128, }}>
            </Avatar>
            {/* <input
            accept="image/*"
            // className={classes.input}
            id="contained-button-file"
            
            type="file"
           />
           <label htmlFor="contained-button-file">
             <IconButton>
              <Avatar 
                src="/images/example.jpg" 
                style={{
                 margin: "10px",
                 width: "60px",
                 height: "60px",
                }} 
               />
             </IconButton>
           </label> */}
           </>
        );
    }
}